import { MetaComp } from '../types/tft'

export const META_COMPS: MetaComp[] = [
  {
    "id": "comp-1776233002536",
    "name": "NOVA",
    "tier": "B",
    "carries": [
      "Kindred",
      "Master Yi"
    ],
    "tank": "Tahm Kench",
    "coreUnits": [
      "Aatrox",
      "Akali",
      "Maokai",
      "Bel'Veth",
      "Kindred",
      "Tahm Kench",
      "Master Yi",
      "Shen",
      "Fiora"
    ],
    "flexUnits": [],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Caitlyn",
      "Rek'Sai",
      "Briar"
    ],
    "playstyle": "standard",
    "description": "",
    "unitBuilds": [
      {
        "champion": "Kindred",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Striker's Flail",
          "Kraken's Fury"
        ],
        "flexItems": []
      },
      {
        "champion": "Tahm Kench",
        "coreItems": [
          "Warmog's Armor",
          "Spirit Visage",
          "Sunfire Cape"
        ],
        "flexItems": [
          "Steadfast Heart"
        ]
      },
      {
        "champion": "Master Yi",
        "coreItems": [
          "Edge of Night",
          "Giant Slayer"
        ],
        "flexItems": [
          "Hand of Justice",
          "Sterak's Gage",
          "Quicksilver"
        ]
      }
    ],
    "recommendedAugments": [
      "tft_augment_aurafarming",
      "tft11_augment_slammin",
      "tft11_augment_slammin_plus",
      "tft9_augment_commander_rollingfordays",
      "tft_augment_grouphug1",
      "tft_augment_grouphug2",
      "tft_augment_sizematters",
      "tft_augment_expectedunexpectedness",
      "tft11_augment_reinfourcement",
      "tft_augment_epicrolldown",
      "tft_augment_speedydoublekill",
      "tft7_augment_urfsgrabbag2",
      "tft16_augment_ultrarapidfire"
    ],
    "recommendedEmblems": [
      "N.O.V.A."
    ],
    "augmentTiers": {
      "base": [
        "tft_augment_aurafarming",
        "tft11_augment_slammin",
        "tft11_augment_slammin_plus",
        "tft9_augment_commander_rollingfordays"
      ],
      "good": [
        "tft_augment_grouphug1",
        "tft_augment_grouphug2",
        "tft_augment_sizematters",
        "tft_augment_expectedunexpectedness",
        "tft11_augment_reinfourcement",
        "tft_augment_epicrolldown",
        "tft_augment_speedydoublekill"
      ],
      "great": [
        "tft7_augment_urfsgrabbag2",
        "tft16_augment_ultrarapidfire"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "recommendedConditions": [],
    "link": "https://tftflow.com/composition/set17/n-o-v-a",
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [
        "N.O.V.A."
      ],
      "op": []
    }
  },
  {
    "id": "comp-1776239119036",
    "name": "Vex Fast 9",
    "tier": "A",
    "carries": [
      "Vex",
      "Blitzcrank"
    ],
    "tank": "Rammus",
    "coreUnits": [
      "Meepsie",
      "Mordekaiser",
      "Karma",
      "The Mighty Mech",
      "Rammus",
      "Shen",
      "Bard",
      "Vex",
      "Blitzcrank",
      "Caitlyn"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Vex",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Jeweled Gauntlet",
          "Striker's Flail"
        ],
        "flexItems": [
          "Void Staff",
          "Giant Slayer"
        ]
      },
      {
        "champion": "Bard",
        "coreItems": [],
        "flexItems": []
      },
      {
        "champion": "Shen",
        "coreItems": [],
        "flexItems": []
      },
      {
        "champion": "Rammus",
        "coreItems": [
          "Warmog's Armor",
          "Steadfast Heart"
        ],
        "flexItems": [
          "Protector's Vow",
          "Crownguard",
          "Bramble Vest"
        ]
      },
      {
        "champion": "Blitzcrank",
        "coreItems": [
          "Jeweled Gauntlet",
          "Hand of Justice",
          "Striker's Flail"
        ],
        "flexItems": [
          "Rabadon's Deathcap"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Milio",
      "Pantheon",
      "Briar",
      "Ezreal"
    ],
    "playstyle": "fast9",
    "description": "",
    "recommendedAugments": [
      "tft11_augment_slammin",
      "tft11_augment_slammin_plus",
      "tft_augment_aurafarming",
      "tft_augment_duoqueue",
      "tft_augment_gildedsteel",
      "tft_augment_moneymonsoon",
      "tft7_augment_lategamespecialist",
      "tft_augment_lategamescaling",
      "tft_augment_upwardmobility",
      "tft6_augment_maxlevel10",
      "tft9_augment_hedgefund",
      "tft9_augment_tiniesttitanplus"
    ],
    "recommendedEmblems": [],
    "augmentTiers": {
      "base": [
        "tft11_augment_slammin",
        "tft11_augment_slammin_plus"
      ],
      "good": [
        "tft_augment_aurafarming",
        "tft_augment_duoqueue",
        "tft_augment_gildedsteel",
        "tft_augment_moneymonsoon",
        "tft7_augment_lategamespecialist",
        "tft_augment_lategamescaling"
      ],
      "great": [
        "tft_augment_upwardmobility",
        "tft6_augment_maxlevel10",
        "tft9_augment_hedgefund",
        "tft9_augment_tiniesttitanplus"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [
        "Statikk Shiv"
      ],
      "op": []
    },
    "recommendedConditions": [],
    "link": "https://tftflow.com/composition/set17/vex-ap-fast-9",
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776239772552",
    "name": "Mecha",
    "tier": "B",
    "carries": [
      "Aurelion Sol"
    ],
    "tank": "The Mighty Mech",
    "coreUnits": [
      "Akali",
      "Urgot",
      "Maokai",
      "The Mighty Mech",
      "Aurelion Sol",
      "Bard",
      "Karma"
    ],
    "flexUnits": [
      "Fiora",
      "Tahm Kench"
    ],
    "unitBuilds": [
      {
        "champion": "Aurelion Sol",
        "coreItems": [
          "Jeweled Gauntlet",
          "Void Staff",
          "Rabadon's Deathcap"
        ],
        "flexItems": []
      },
      {
        "champion": "The Mighty Mech",
        "coreItems": [
          "Gargoyle Stoneplate",
          "Sterak's Gage",
          "Titan's Resolve"
        ],
        "flexItems": []
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Pantheon",
      "Aatrox",
      "Ezreal",
      "Milio",
      "Caitlyn"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedAugments": [
      "tft11_augment_slammin",
      "tft11_augment_slammin_plus",
      "tft9_augment_healingorbsi",
      "tft9_augment_healingorbsii",
      "tft9_augment_pandorasitems2",
      "tft9_augment_pandorasradiantbox",
      "tft9_augment_commander_partialascension",
      "tft10_augment_goodforsomethingsilver",
      "tft_augment_twinguardians",
      "tft_augment_arcaneviktory",
      "tft6_augment_secondwind1",
      "tft6_augment_pandorasitems",
      "tft_augment_epicrolldown",
      "tft11_augment_reinfourcement",
      "tft_augment_exclusivecustomization",
      "tft_augment_patienceisavirtue",
      "tft_augment_itemgargoylestoneplate",
      "tft_augment_findyourcenter",
      "tft_augment_thegoldendragon",
      "tft_augment_expedition"
    ],
    "recommendedEmblems": [],
    "recommendedConditions": [
      "tft17_augment_ekkogodaugment",
      "tft17_augment_kaylegodaugment"
    ],
    "augmentTiers": {
      "base": [
        "tft11_augment_slammin",
        "tft11_augment_slammin_plus",
        "tft9_augment_healingorbsi",
        "tft9_augment_healingorbsii",
        "tft9_augment_pandorasitems2",
        "tft9_augment_pandorasradiantbox",
        "tft9_augment_commander_partialascension",
        "tft10_augment_goodforsomethingsilver",
        "tft_augment_twinguardians",
        "tft_augment_arcaneviktory"
      ],
      "good": [
        "tft6_augment_secondwind1",
        "tft6_augment_pandorasitems",
        "tft_augment_epicrolldown",
        "tft11_augment_reinfourcement",
        "tft_augment_exclusivecustomization",
        "tft_augment_patienceisavirtue"
      ],
      "great": [
        "tft_augment_itemgargoylestoneplate",
        "tft_augment_findyourcenter",
        "tft_augment_thegoldendragon"
      ],
      "op": [
        "tft_augment_expedition"
      ]
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Varus's Obsession",
        "Ahri's Aura",
        "Ekko's Patience"
      ],
      "great": [
        "Silvermere Dawn"
      ],
      "op": []
    },
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/mecha"
  },
  {
    "id": "comp-1776246726367",
    "name": "LeBlanc Karma",
    "tier": "B",
    "carries": [
      "LeBlanc",
      "Karma"
    ],
    "tank": "Nunu & Willump",
    "coreUnits": [
      "Leona",
      "Mordekaiser",
      "Illaoi",
      "Meepsie",
      "Zoe",
      "Nunu & Willump",
      "LeBlanc",
      "Karma"
    ],
    "flexUnits": [
      "Morgana"
    ],
    "unitBuilds": [
      {
        "champion": "Nunu & Willump",
        "coreItems": [
          "Protector's Vow",
          "Protector's Vow",
          "Protector's Vow"
        ],
        "flexItems": [
          "Warmog's Armor",
          "Bramble Vest",
          "Dragon's Claw"
        ]
      },
      {
        "champion": "LeBlanc",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Giant Slayer",
          "Jeweled Gauntlet"
        ],
        "flexItems": [
          "Hextech Gunblade"
        ]
      },
      {
        "champion": "Karma",
        "coreItems": [
          "Spear of Shojin",
          "Void Staff",
          "Morellonomicon"
        ],
        "flexItems": [
          "Blue Buff"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Lissandra",
      "Cho'Gath"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [
      "tft17_augment_kaylegodaugment"
    ],
    "recommendedAugments": [
      "tft11_augment_slammin",
      "tft11_augment_slammin_plus",
      "tft9_augment_learningfromexperience2",
      "tft_augment_frontlinefoundation",
      "tft_augment_epicrolldown",
      "tft9_augment_jeweledlotus",
      "tft6_augment_secondwind1",
      "tft_augment_shimmerscaleessence",
      "tft_augment_speedydoublekill",
      "tft_augment_heavyisthecrown",
      "tft_augment_holdtheline"
    ],
    "recommendedEmblems": [
      "Vanguard",
      "Voyager"
    ],
    "augmentTiers": {
      "base": [
        "tft11_augment_slammin",
        "tft11_augment_slammin_plus",
        "tft9_augment_learningfromexperience2"
      ],
      "good": [
        "tft_augment_frontlinefoundation",
        "tft_augment_epicrolldown",
        "tft9_augment_jeweledlotus",
        "tft6_augment_secondwind1",
        "tft_augment_shimmerscaleessence",
        "tft_augment_speedydoublekill",
        "tft_augment_heavyisthecrown"
      ],
      "great": [
        "tft_augment_holdtheline"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Statikk Shiv",
        "Flickerblades"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/vanguard-leblanc",
    "emblemTiers": {
      "base": [
        "Vanguard"
      ],
      "good": [
        "Voyager"
      ],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776247471663",
    "name": "KIZZ",
    "tier": "B",
    "carries": [
      "Fizz",
      "Kai'Sa"
    ],
    "tank": "Ornn",
    "coreUnits": [
      "Meepsie",
      "Fizz",
      "Ornn",
      "Kai'Sa",
      "Rhaast",
      "Rammus",
      "Riven"
    ],
    "flexUnits": [
      "Karma"
    ],
    "unitBuilds": [
      {
        "champion": "Ornn",
        "coreItems": [
          "Evenshroud",
          "Spirit Visage",
          "Steadfast Heart"
        ],
        "flexItems": [
          "Warmog's Armor",
          "Sunfire Cape"
        ]
      },
      {
        "champion": "Fizz",
        "coreItems": [
          "Jeweled Gauntlet",
          "Nashor's Tooth",
          "Hand of Justice"
        ],
        "flexItems": []
      },
      {
        "champion": "Kai'Sa",
        "coreItems": [
          "Infinity Edge",
          "Striker's Flail",
          "Spear of Shojin"
        ],
        "flexItems": [
          "Blue Buff"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Lissandra",
      "Pantheon",
      "Ezreal",
      "Cho'Gath"
    ],
    "playstyle": "3cost-reroll",
    "description": "",
    "recommendedConditions": [
      "tft17_augment_kaylegodaugment"
    ],
    "recommendedAugments": [
      "tft6_augment_calculatedloss",
      "tft9_augment_commander_rollingfordays",
      "tft10_augment_heroicgrabbag",
      "tft_augment_heroicgrabbagplus",
      "tft_augment_heroicgrabbagplusplus",
      "tft_augment_legionofthrees",
      "tft6_augment_tradesector",
      "tft9_augment_jeweledlotus",
      "tft_augment_backlineblueprint",
      "tft6_augment_gachaaddict",
      "tft_augment_patienceisavirtue"
    ],
    "recommendedEmblems": [
      "Rogue",
      "Voyager"
    ],
    "augmentTiers": {
      "base": [],
      "good": [
        "tft6_augment_calculatedloss",
        "tft9_augment_commander_rollingfordays",
        "tft10_augment_heroicgrabbag",
        "tft_augment_heroicgrabbagplus",
        "tft_augment_heroicgrabbagplusplus",
        "tft_augment_legionofthrees",
        "tft6_augment_tradesector",
        "tft9_augment_jeweledlotus",
        "tft_augment_backlineblueprint"
      ],
      "great": [
        "tft6_augment_gachaaddict",
        "tft_augment_patienceisavirtue"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Lich Bane",
        "Gold Collector"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/kaisa-rogues",
    "emblemTiers": {
      "base": [
        "Rogue",
        "Voyager"
      ],
      "good": [],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776247803690",
    "name": "Primordians",
    "tier": "B",
    "carries": [
      "Bel'Veth",
      "Akali",
      "Kindred"
    ],
    "tank": "Rek'Sai",
    "coreUnits": [
      "Aatrox",
      "Briar",
      "Rek'Sai",
      "Bel'Veth",
      "Caitlyn",
      "Akali",
      "Maokai",
      "Kindred"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Kindred",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Giant Slayer",
          "Kraken's Fury"
        ],
        "flexItems": []
      },
      {
        "champion": "Bel'Veth",
        "coreItems": [
          "Giant Slayer",
          "Quicksilver",
          "Kraken's Fury"
        ],
        "flexItems": []
      },
      {
        "champion": "Rek'Sai",
        "coreItems": [
          "Warmog's Armor",
          "Sunfire Cape",
          "Spirit Visage"
        ],
        "flexItems": [
          "Dragon's Claw",
          "Bramble Vest"
        ]
      },
      {
        "champion": "Akali",
        "coreItems": [
          "Striker's Flail",
          "Hand of Justice",
          "Edge of Night"
        ],
        "flexItems": []
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [],
    "playstyle": "2cost-reroll",
    "description": "",
    "recommendedConditions": [
      "tft17_augment_varusgodaugment_boonofstars"
    ],
    "recommendedAugments": [
      "tft9_augment_missedconnections",
      "tft6_augment_tradesector",
      "tft_augment_waverider",
      "tft_augment_lineup",
      "tft_augment_boxinglessons",
      "tft_augment_infinityprotection",
      "tft6_augment_gachaaddict",
      "tft_augment_noscoutnopivot"
    ],
    "recommendedEmblems": [
      "N.O.V.A.",
      "Rogue"
    ],
    "augmentTiers": {
      "base": [],
      "good": [
        "tft9_augment_missedconnections",
        "tft6_augment_tradesector",
        "tft_augment_waverider",
        "tft_augment_lineup",
        "tft_augment_boxinglessons",
        "tft_augment_infinityprotection"
      ],
      "great": [
        "tft6_augment_gachaaddict",
        "tft_augment_noscoutnopivot"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Rapid Firecannon",
        "Evelynn's Instinct",
        "Flickerblades"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/primordian-reroll",
    "emblemTiers": {
      "base": [
        "N.O.V.A.",
        "Rogue"
      ],
      "good": [],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776247980040",
    "name": "In the Groove",
    "tier": "A",
    "carries": [
      "Blitzcrank",
      "Nami",
      "Riven"
    ],
    "tank": "",
    "coreUnits": [
      "Nasus",
      "Gwen",
      "Pantheon",
      "Ornn",
      "Tahm Kench",
      "Blitzcrank",
      "Shen",
      "Nami",
      "Riven"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Blitzcrank",
        "coreItems": [
          "Bloodthirster",
          "Morellonomicon",
          "Ionic Spark"
        ],
        "flexItems": [
          "Jeweled Gauntlet",
          "Striker's Flail",
          "Hand of Justice"
        ]
      },
      {
        "champion": "Tahm Kench",
        "coreItems": [
          "Warmog's Armor",
          "Sunfire Cape",
          "Spirit Visage"
        ],
        "flexItems": [
          "Crownguard",
          "Steadfast Heart"
        ]
      },
      {
        "champion": "Nami",
        "coreItems": [
          "Spear of Shojin",
          "Striker's Flail",
          "Jeweled Gauntlet"
        ],
        "flexItems": [
          "Nashor's Tooth"
        ]
      },
      {
        "champion": "Riven",
        "coreItems": [
          "Bloodthirster",
          "Sterak's Gage"
        ],
        "flexItems": [
          "Edge of Night",
          "Titan's Resolve"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Teemo"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft9_augment_commander_ascension",
      "tft11_augment_slammin",
      "tft11_augment_slammin_plus",
      "tft_augment_traittree",
      "tft_augment_spreadingroots",
      "tft10_augment_littlebuddies",
      "tft_augment_climbtheladder1",
      "tft_augment_gildedsteel",
      "tft_augment_bodyguardtraining",
      "tft6_augment_cyberneticuplink2",
      "tft_augment_crymeariver",
      "tft_augment_cosmicrestart",
      "tft_augment_spreadingrootsplus",
      "tft_augment_traittreeplus"
    ],
    "recommendedEmblems": [
      "Bastion",
      "Brawler",
      "Vanguard",
      "Timebreaker",
      "Rogue",
      "Space Groove"
    ],
    "augmentTiers": {
      "base": [
        "tft9_augment_commander_ascension",
        "tft11_augment_slammin",
        "tft11_augment_slammin_plus",
        "tft_augment_traittree",
        "tft_augment_spreadingroots"
      ],
      "good": [
        "tft10_augment_littlebuddies",
        "tft_augment_climbtheladder1",
        "tft_augment_gildedsteel",
        "tft_augment_bodyguardtraining",
        "tft6_augment_cyberneticuplink2",
        "tft_augment_crymeariver",
        "tft_augment_cosmicrestart"
      ],
      "great": [
        "tft_augment_spreadingrootsplus",
        "tft_augment_traittreeplus"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Death's Defiance"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/space-groove-nami",
    "emblemTiers": {
      "base": [
        "Bastion",
        "Brawler",
        "Vanguard"
      ],
      "good": [
        "Timebreaker",
        "Rogue"
      ],
      "great": [
        "Space Groove"
      ],
      "op": []
    }
  },
  {
    "id": "comp-1776248204704",
    "name": "Graves Fast 9",
    "tier": "A",
    "carries": [
      "Graves",
      "Vex"
    ],
    "tank": "",
    "coreUnits": [
      "Aatrox",
      "Akali",
      "Shen",
      "Graves",
      "Fiora",
      "Morgana",
      "Vex",
      "Nunu & Willump",
      "Blitzcrank"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Graves",
        "coreItems": [
          "Striker's Flail",
          "Sterak's Gage",
          "Quicksilver"
        ],
        "flexItems": [
          "Infinity Edge",
          "Spear of Shojin",
          "Deathblade",
          "Edge of Night"
        ]
      },
      {
        "champion": "Vex",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Jeweled Gauntlet",
          "Striker's Flail"
        ],
        "flexItems": [
          "Hextech Gunblade",
          "Void Staff"
        ]
      },
      {
        "champion": "Tahm Kench",
        "coreItems": [
          "Evenshroud",
          "Sunfire Cape",
          "Crownguard"
        ],
        "flexItems": []
      },
      {
        "champion": "Nunu & Willump",
        "coreItems": [
          "Protector's Vow",
          "Protector's Vow",
          "Protector's Vow"
        ],
        "flexItems": [
          "Warmog's Armor",
          "Sunfire Cape",
          "Spirit Visage"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Pantheon",
      "Ezreal",
      "Caitlyn"
    ],
    "playstyle": "fast9",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft_augment_patienceisavirtue",
      "tft_augment_moneymonsoon",
      "tft11_augment_slammin_plus",
      "tft11_augment_slammin",
      "tft9_augment_buildingacollectionplusplus",
      "tft9_augment_riskymoves",
      "tft7_augment_lategamespecialist",
      "tft_augment_aurafarming",
      "tft_augment_gildedsteel",
      "tft_augment_duoqueue",
      "tft6_augment_onetwofive",
      "tft_augment_upwardmobility",
      "tft_augment_lategamescaling",
      "tft9_augment_hedgefund",
      "tft6_augment_maxlevel10"
    ],
    "recommendedEmblems": [],
    "augmentTiers": {
      "base": [
        "tft_augment_patienceisavirtue",
        "tft_augment_moneymonsoon",
        "tft11_augment_slammin_plus",
        "tft11_augment_slammin",
        "tft9_augment_buildingacollectionplusplus",
        "tft9_augment_riskymoves"
      ],
      "good": [
        "tft7_augment_lategamespecialist",
        "tft_augment_aurafarming",
        "tft_augment_gildedsteel",
        "tft_augment_duoqueue",
        "tft6_augment_onetwofive",
        "tft_augment_upwardmobility",
        "tft_augment_lategamescaling"
      ],
      "great": [
        "tft9_augment_hedgefund",
        "tft6_augment_maxlevel10"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Statikk Shiv",
        "Death's Defiance"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/graves-fast-9",
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776248476602",
    "name": "Corki Riven",
    "tier": "B",
    "carries": [
      "Riven",
      "Corki"
    ],
    "tank": "Rammus",
    "coreUnits": [
      "Meepsie",
      "Milio",
      "Fizz",
      "Rammus",
      "Riven",
      "Corki",
      "The Mighty Mech",
      "Shen",
      "Bard"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Corki",
        "coreItems": [
          "Blue Buff",
          "Deathblade"
        ],
        "flexItems": [
          "Last Whisper",
          "Striker's Flail"
        ]
      },
      {
        "champion": "Riven",
        "coreItems": [
          "Bloodthirster",
          "Sterak's Gage"
        ],
        "flexItems": [
          "Edge of Night",
          "Titan's Resolve"
        ]
      },
      {
        "champion": "Rammus",
        "coreItems": [
          "Protector's Vow",
          "Bramble Vest",
          "Steadfast Heart"
        ],
        "flexItems": [
          "Sunfire Cape",
          "Dragon's Claw"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Pantheon",
      "Ezreal",
      "Gnar"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft11_augment_slammin",
      "tft11_augment_slammin_plus",
      "tft9_augment_commander_ascension",
      "tft9_augment_biggrabbag",
      "tft_augment_climbtheladder2",
      "tft_augment_traittree",
      "tft_augment_spreadingroots",
      "tft_augment_branchingoutplus",
      "tft_augment_branchingout",
      "tft11_augment_reinfourcement",
      "tft_augment_componentquestsword",
      "tft_augment_epicrolldown",
      "tft_augment_spreadingrootsplus",
      "tft_augment_traittreeplus",
      "tft_augment_tragicalblade",
      "tft_augment_swordoverflow"
    ],
    "recommendedEmblems": [
      "Bastion",
      "Voyager",
      "Timebreaker",
      "Rogue"
    ],
    "augmentTiers": {
      "base": [
        "tft11_augment_slammin",
        "tft11_augment_slammin_plus",
        "tft9_augment_commander_ascension",
        "tft9_augment_biggrabbag",
        "tft_augment_climbtheladder2",
        "tft_augment_traittree",
        "tft_augment_spreadingroots",
        "tft_augment_branchingoutplus",
        "tft_augment_branchingout"
      ],
      "good": [
        "tft11_augment_reinfourcement",
        "tft_augment_componentquestsword",
        "tft_augment_epicrolldown",
        "tft_augment_spreadingrootsplus",
        "tft_augment_traittreeplus"
      ],
      "great": [
        "tft_augment_tragicalblade",
        "tft_augment_swordoverflow"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Death's Defiance",
        "Gold Collector"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/meeple-corki",
    "emblemTiers": {
      "base": [
        "Bastion"
      ],
      "good": [],
      "great": [
        "Voyager",
        "Timebreaker",
        "Rogue"
      ],
      "op": []
    }
  },
  {
    "id": "comp-1776248832378",
    "name": "Xayah",
    "tier": "B",
    "carries": [
      "Xayah",
      "Jhin"
    ],
    "tank": "Nunu & Willump",
    "coreUnits": [
      "Jax",
      "Mordekaiser",
      "Rhaast",
      "Nunu & Willump",
      "Xayah",
      "Jhin",
      "Bard"
    ],
    "flexUnits": [
      "Lulu",
      "Shen",
      "Rammus",
      "Gnar"
    ],
    "unitBuilds": [
      {
        "champion": "Nunu & Willump",
        "coreItems": [
          "Protector's Vow",
          "Protector's Vow",
          "Protector's Vow"
        ],
        "flexItems": [
          "Spirit Visage",
          "Steadfast Heart",
          "Evenshroud"
        ]
      },
      {
        "champion": "Xayah",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Kraken's Fury",
          "Red Buff"
        ],
        "flexItems": [
          "Last Whisper"
        ]
      },
      {
        "champion": "Jhin",
        "coreItems": [
          "Infinity Edge",
          "Giant Slayer",
          "Deathblade"
        ],
        "flexItems": [
          "Hextech Gunblade"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Talon",
      "Twisted Fate"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [
      "stargazer_boar",
      "stargazer_serpent",
      "stargazer_altar"
    ],
    "recommendedAugments": [
      "tft_augment_patienceisavirtue",
      "tft9_augment_learningfromexperience2",
      "tft7_augment_clutteredmind",
      "tft6_augment_pandorasitems",
      "tft_augment_shimmerscaleessence",
      "tft_augment_componentquestbow",
      "tft_augment_thebaronslair",
      "tft_augment_comebackstory",
      "tft_augment_epicrolldown",
      "tft_augment_maythefoursbewithyou"
    ],
    "recommendedEmblems": [
      "Stargazer"
    ],
    "augmentTiers": {
      "base": [
        "tft_augment_patienceisavirtue",
        "tft9_augment_learningfromexperience2",
        "tft7_augment_clutteredmind",
        "tft6_augment_pandorasitems"
      ],
      "good": [
        "tft_augment_shimmerscaleessence",
        "tft_augment_componentquestbow",
        "tft_augment_thebaronslair",
        "tft_augment_comebackstory",
        "tft_augment_epicrolldown"
      ],
      "great": [
        "tft_augment_maythefoursbewithyou"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/stargazer-xayah",
    "emblemTiers": {
      "base": [],
      "good": [
        "Stargazer"
      ],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776249107966",
    "name": "Conduit MF Viktor",
    "tier": "C",
    "carries": [
      "Miss Fortune",
      "Viktor"
    ],
    "tank": "Maokai",
    "coreUnits": [
      "Aatrox",
      "Maokai",
      "Ornn",
      "Miss Fortune",
      "Viktor",
      "Rhaast",
      "Gragas",
      "Bard"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Viktor",
        "coreItems": [
          "Jeweled Gauntlet",
          "Archangel's Staff",
          "Drone Uplink"
        ],
        "flexItems": [
          "Sympathetic Implant"
        ]
      },
      {
        "champion": "Miss Fortune",
        "coreItems": [
          "Infinity Edge",
          "Blue Buff",
          "Striker's Flail"
        ],
        "flexItems": []
      },
      {
        "champion": "Ornn",
        "coreItems": [
          "Sunfire Cape",
          "Spirit Visage",
          "Bramble Vest"
        ],
        "flexItems": [
          "Warmog's Armor"
        ]
      },
      {
        "champion": "Maokai",
        "coreItems": [
          "Spirit Visage",
          "Sunfire Cape",
          "Warmog's Armor"
        ],
        "flexItems": []
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Pyke",
      "Akali",
      "Caitlyn"
    ],
    "playstyle": "3cost-reroll",
    "description": "",
    "recommendedConditions": [
      "psionic_drone_uplink",
      "psionic_sympathetic_implant"
    ],
    "recommendedAugments": [
      "tft9_augment_jeweledlotus",
      "tft10_augment_heroicgrabbag",
      "tft6_augment_tradesector",
      "tft6_augment_calculatedloss",
      "tft6_augment_tradesector2",
      "tft9_augment_commander_rollingfordays",
      "tft_augment_bronzeforlifei",
      "tft_augment_bronzeforlife2",
      "tft_augment_patienceisavirtue",
      "tft_augment_legionofthrees",
      "tft6_augment_gachaaddict"
    ],
    "recommendedEmblems": [],
    "augmentTiers": {
      "base": [
        "tft9_augment_jeweledlotus"
      ],
      "good": [
        "tft10_augment_heroicgrabbag",
        "tft6_augment_tradesector",
        "tft6_augment_calculatedloss",
        "tft6_augment_tradesector2",
        "tft9_augment_commander_rollingfordays",
        "tft_augment_bronzeforlifei",
        "tft_augment_bronzeforlife2"
      ],
      "great": [
        "tft_augment_patienceisavirtue",
        "tft_augment_legionofthrees",
        "tft6_augment_gachaaddict"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Gold Collector",
        "Sniper's Focus"
      ],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776249372209",
    "name": "Bronze Viktor",
    "tier": "A",
    "carries": [
      "Viktor",
      "Nami"
    ],
    "tank": "Illaoi",
    "coreUnits": [
      "Lissandra",
      "Mordekaiser",
      "Pyke",
      "Meepsie",
      "Rhaast",
      "Illaoi",
      "Viktor",
      "Nami"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Viktor",
        "coreItems": [
          "Archangel's Staff",
          "Jeweled Gauntlet",
          "Drone Uplink"
        ],
        "flexItems": [
          "Sympathetic Implant"
        ]
      },
      {
        "champion": "Illaoi",
        "coreItems": [
          "Sunfire Cape",
          "Dragon's Claw",
          "Bramble Vest"
        ],
        "flexItems": [
          "Spirit Visage",
          "Ionic Spark"
        ]
      },
      {
        "champion": "Nami",
        "coreItems": [
          "Spear of Shojin",
          "Jeweled Gauntlet",
          "Striker's Flail"
        ],
        "flexItems": [
          "Void Staff",
          "Morellonomicon"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Zoe",
      "Leona"
    ],
    "playstyle": "3cost-reroll",
    "description": "",
    "recommendedConditions": [
      "psionic_drone_uplink",
      "psionic_sympathetic_implant"
    ],
    "recommendedAugments": [
      "tft6_augment_calculatedloss",
      "tft_augment_legionofthrees",
      "tft9_augment_jeweledlotus",
      "tft6_augment_diversify1",
      "tft_augment_boxinglessons",
      "tft_augment_holdtheline",
      "tft10_augment_heroicgrabbag",
      "tft6_augment_tradesector2",
      "tft_augment_glasscannonii",
      "tft_augment_bronzeforlifei",
      "tft_augment_patienceisavirtue",
      "tft6_augment_gachaaddict",
      "tft_augment_bronzeforlife2"
    ],
    "recommendedEmblems": [
      "Psionic",
      "Voyager"
    ],
    "augmentTiers": {
      "base": [
        "tft6_augment_calculatedloss",
        "tft_augment_legionofthrees",
        "tft9_augment_jeweledlotus",
        "tft6_augment_diversify1",
        "tft_augment_boxinglessons",
        "tft_augment_holdtheline"
      ],
      "good": [
        "tft10_augment_heroicgrabbag",
        "tft6_augment_tradesector2",
        "tft_augment_glasscannonii"
      ],
      "great": [
        "tft_augment_bronzeforlifei",
        "tft_augment_patienceisavirtue",
        "tft6_augment_gachaaddict"
      ],
      "op": [
        "tft_augment_bronzeforlife2"
      ]
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/viktor-illaoi-reroll",
    "emblemTiers": {
      "base": [
        "Psionic"
      ],
      "good": [
        "Voyager"
      ],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776249525249",
    "name": "Shooting Stars",
    "tier": "B",
    "carries": [
      "Caitlyn",
      "Talon",
      "Twisted Fate"
    ],
    "tank": "Jax",
    "coreUnits": [
      "Caitlyn",
      "Talon",
      "Twisted Fate",
      "Aatrox",
      "Jax",
      "Milio",
      "Riven",
      "Corki"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Caitlyn",
        "coreItems": [
          "Guinsoo's Rageblade",
          "Deathblade",
          "Giant Slayer"
        ],
        "flexItems": [
          "Kraken's Fury"
        ]
      },
      {
        "champion": "Twisted Fate",
        "coreItems": [
          "Spear of Shojin",
          "Nashor's Tooth",
          "Rabadon's Deathcap"
        ],
        "flexItems": [
          "Nashor's Tooth"
        ]
      },
      {
        "champion": "Talon",
        "coreItems": [
          "Spear of Shojin",
          "Edge of Night",
          "Hextech Gunblade"
        ],
        "flexItems": []
      },
      {
        "champion": "Jax",
        "coreItems": [
          "Protector's Vow",
          "Gargoyle Stoneplate",
          "Crownguard"
        ],
        "flexItems": []
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [],
    "playstyle": "1cost-reroll",
    "description": "",
    "recommendedConditions": [
      "tft17_augment_varusgodaugment_boonofstars",
      "stargazer_medallion",
      "stargazer_altar"
    ],
    "recommendedAugments": [
      "tft7_augment_pandorasbench",
      "tft9_augment_buildingacollectionplusplus",
      "tft9_augment_missedconnections",
      "tft_augment_deadliercaps",
      "tft_augment_thebaronslair",
      "tft_augment_waverider",
      "tft6_augment_tradesector",
      "tft_augment_componentquestrod",
      "tft_augment_noscoutnopivot",
      "tft6_augment_gachaaddict",
      "tft_augment_earlylearning",
      "tft_augment_chargetransfer2",
      "tft_augment_wandoverflow"
    ],
    "recommendedEmblems": [],
    "augmentTiers": {
      "base": [
        "tft7_augment_pandorasbench",
        "tft9_augment_buildingacollectionplusplus"
      ],
      "good": [
        "tft9_augment_missedconnections",
        "tft_augment_deadliercaps",
        "tft_augment_thebaronslair",
        "tft_augment_waverider",
        "tft6_augment_tradesector",
        "tft_augment_componentquestrod"
      ],
      "great": [
        "tft_augment_noscoutnopivot",
        "tft6_augment_gachaaddict",
        "tft_augment_earlylearning",
        "tft_augment_chargetransfer2",
        "tft_augment_wandoverflow"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Luden's Tempest",
        "Dawncore"
      ],
      "great": [],
      "op": []
    },
    "link": "https://tftflow.com/composition/set17/twisted-fate-reroll-2",
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776406889062",
    "name": "Anima Viktor",
    "tier": "A",
    "carries": [
      "Aurora",
      "Viktor"
    ],
    "tank": "Illaoi",
    "coreUnits": [
      "Mordekaiser",
      "Aurora",
      "Illaoi",
      "Rhaast",
      "Pyke",
      "Karma",
      "Viktor"
    ],
    "flexUnits": [
      "Jinx"
    ],
    "unitBuilds": [
      {
        "champion": "Aurora",
        "coreItems": [
          "Jeweled Gauntlet",
          "Nashor's Tooth",
          "Nashor's Tooth"
        ],
        "flexItems": [
          "Spear of Shojin",
          "Void Staff"
        ]
      },
      {
        "champion": "Viktor",
        "coreItems": [
          "Jeweled Gauntlet",
          "Archangel's Staff",
          "Drone Uplink"
        ],
        "flexItems": [
          "Sympathetic Implant"
        ]
      },
      {
        "champion": "Illaoi",
        "coreItems": [
          "Sunfire Cape",
          "Spirit Visage"
        ],
        "flexItems": [
          "Ionic Spark"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Briar"
    ],
    "playstyle": "3cost-reroll",
    "description": "",
    "recommendedConditions": [
      "psionic_drone_uplink",
      "psionic_sympathetic_implant"
    ],
    "recommendedAugments": [
      "tft9_augment_armybuilding",
      "tft6_augment_tradesector2",
      "tft9_augment_jeweledlotus",
      "tft9_augment_commander_rollingfordays",
      "tft6_augment_calculatedloss",
      "tft10_augment_heroicgrabbag",
      "tft_augment_heroicgrabbagplus",
      "tft_augment_heroicgrabbagplusplus",
      "tft6_augment_tinytitans",
      "tft6_augment_gachaaddict",
      "tft_augment_patienceisavirtue",
      "tft17_augment_animasquad_commander",
      "tft9_augment_tiniesttitanplus"
    ],
    "augmentTiers": {
      "base": [
        "tft9_augment_armybuilding",
        "tft6_augment_tradesector2",
        "tft9_augment_jeweledlotus"
      ],
      "good": [
        "tft9_augment_commander_rollingfordays",
        "tft6_augment_calculatedloss",
        "tft10_augment_heroicgrabbag",
        "tft_augment_heroicgrabbagplus",
        "tft_augment_heroicgrabbagplusplus"
      ],
      "great": [
        "tft6_augment_tinytitans",
        "tft6_augment_gachaaddict",
        "tft_augment_patienceisavirtue",
        "tft17_augment_animasquad_commander"
      ],
      "op": [
        "tft9_augment_tiniesttitanplus"
      ]
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "recommendedEmblems": [],
    "link": "https://tftflow.com/composition/set17/anima-viktor-reroll",
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    }
  },
  {
    "id": "comp-1776510954992",
    "name": "Veigar Printer",
    "tier": "B",
    "carries": [
      "Veigar",
      "Corki"
    ],
    "tank": "Rammus",
    "coreUnits": [
      "Veigar",
      "Meepsie",
      "Mordekaiser",
      "Illaoi",
      "Lissandra",
      "Rammus",
      "Corki",
      "Shen",
      "Bard"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Veigar",
        "coreItems": [
          "Blue Buff",
          "Jeweled Gauntlet",
          "Nashor's Tooth"
        ],
        "flexItems": []
      },
      {
        "champion": "Corki",
        "coreItems": [
          "Blue Buff",
          "Deathblade",
          "Last Whisper"
        ],
        "flexItems": []
      },
      {
        "champion": "Rammus",
        "coreItems": [
          "Bramble Vest",
          "Protector's Vow",
          "Steadfast Heart"
        ],
        "flexItems": []
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft_augment_chargetransfer1",
      "tft_augment_chargetransfer2",
      "tft_augment_climbtheladder1",
      "tft_augment_climbtheladder2",
      "tft_augment_worththewaitgold"
    ],
    "augmentTiers": {
      "base": [
        "tft_augment_chargetransfer1",
        "tft_augment_chargetransfer2",
        "tft_augment_climbtheladder1"
      ],
      "good": [
        "tft_augment_climbtheladder2",
        "tft_augment_worththewaitgold"
      ],
      "great": [],
      "op": []
    },
    "artifactTiers": {
      "base": [
        "Gold Collector"
      ],
      "good": [],
      "great": [],
      "op": []
    },
    "emblemTiers": {
      "base": [],
      "good": [
        "Meeple"
      ],
      "great": [],
      "op": []
    },
    "recommendedEmblems": [
      "Meeple"
    ],
    "link": "https://tftflow.com/composition/set17/meeple-veigar"
  },
  {
    "id": "comp-1776511254122",
    "name": "Shepherds",
    "tier": "B",
    "carries": [
      "Karma",
      "LeBlanc"
    ],
    "tank": "Illaoi",
    "coreUnits": [
      "Lissandra",
      "Leona",
      "Meepsie",
      "Illaoi",
      "Karma",
      "LeBlanc",
      "The Mighty Mech",
      "Sona"
    ],
    "flexUnits": [
      "Morgana"
    ],
    "unitBuilds": [
      {
        "champion": "Karma",
        "coreItems": [
          "Void Staff",
          "Morellonomicon",
          "Spear of Shojin"
        ],
        "flexItems": []
      },
      {
        "champion": "LeBlanc",
        "coreItems": [
          "Giant Slayer",
          "Jeweled Gauntlet",
          "Guinsoo's Rageblade"
        ],
        "flexItems": [
          "Hextech Gunblade",
          "Striker's Flail"
        ]
      },
      {
        "champion": "Illaoi",
        "coreItems": [
          "Spirit Visage",
          "Sunfire Cape",
          "Ionic Spark"
        ],
        "flexItems": [
          "Warmog's Armor",
          "Bramble Vest",
          "Dragon's Claw"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Mordekaiser",
      "Zoe"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft_augment_aurafarming",
      "tft_augment_epicrolldown",
      "tft_augment_gildedsteel",
      "tft9_augment_jeweledlotus",
      "tft_augment_urfsgambit",
      "tft7_augment_urfsgrabbag2",
      "tft_augment_speedydoublekill",
      "tft_augment_glasscannonii",
      "tft_augment_heavyisthecrown"
    ],
    "augmentTiers": {
      "base": [
        "tft_augment_aurafarming",
        "tft_augment_epicrolldown",
        "tft_augment_gildedsteel",
        "tft9_augment_jeweledlotus"
      ],
      "good": [
        "tft_augment_urfsgambit",
        "tft7_augment_urfsgrabbag2",
        "tft_augment_speedydoublekill",
        "tft_augment_glasscannonii",
        "tft_augment_heavyisthecrown"
      ],
      "great": [],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Flickerblades",
        "Statikk Shiv"
      ],
      "great": [],
      "op": []
    },
    "emblemTiers": {
      "base": [],
      "good": [
        "Voyager"
      ],
      "great": [
        "Shepherd"
      ],
      "op": []
    },
    "recommendedEmblems": [
      "Voyager",
      "Shepherd"
    ],
    "link": "https://tftflow.com/composition/set17/shepherd-leblanc"
  },
  {
    "id": "comp-1776511496221",
    "name": "Knocked Up Samira",
    "tier": "B",
    "carries": [
      "Samira",
      "Xayah"
    ],
    "tank": "Nunu & Willump",
    "coreUnits": [
      "Jax",
      "Samira",
      "Ornn",
      "Rhaast",
      "Nunu & Willump",
      "Xayah",
      "Blitzcrank"
    ],
    "flexUnits": [
      "Jhin"
    ],
    "unitBuilds": [
      {
        "champion": "Nunu & Willump",
        "coreItems": [
          "Protector's Vow",
          "Protector's Vow",
          "Protector's Vow"
        ],
        "flexItems": [
          "Spirit Visage",
          "Warmog's Armor",
          "Sunfire Cape"
        ]
      },
      {
        "champion": "Xayah",
        "coreItems": [
          "Last Whisper",
          "Guinsoo's Rageblade",
          "Kraken's Fury"
        ],
        "flexItems": []
      },
      {
        "champion": "Samira",
        "coreItems": [
          "Spear of Shojin",
          "Deathblade",
          "Giant Slayer"
        ],
        "flexItems": [
          "Infinity Edge",
          "Last Whisper"
        ]
      },
      {
        "champion": "Ornn",
        "coreItems": [
          "Warmog's Armor",
          "Sunfire Cape",
          "Spirit Visage"
        ],
        "flexItems": [
          "Evenshroud",
          "Bramble Vest",
          "Dragon's Claw"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Nasus",
      "Pantheon",
      "Ezreal",
      "Rek'Sai"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft6_augment_calculatedloss",
      "tft9_augment_commander_rollingfordays",
      "tft10_augment_heroicgrabbag",
      "tft_augment_exclusivecustomization",
      "tft_augment_legionofthrees",
      "tft_augment_patienceisavirtue",
      "tft_augment_tragicalblade",
      "tft_augment_swordoverflow",
      "tft6_augment_tradesector",
      "tft6_augment_gachaaddict",
      "tft_augment_twotanky"
    ],
    "augmentTiers": {
      "base": [
        "tft6_augment_calculatedloss",
        "tft9_augment_commander_rollingfordays",
        "tft10_augment_heroicgrabbag",
        "tft_augment_exclusivecustomization",
        "tft_augment_legionofthrees"
      ],
      "good": [
        "tft_augment_patienceisavirtue",
        "tft_augment_tragicalblade",
        "tft_augment_swordoverflow",
        "tft6_augment_tradesector"
      ],
      "great": [
        "tft6_augment_gachaaddict",
        "tft_augment_twotanky"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "emblemTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "recommendedEmblems": [],
    "link": "https://tftflow.com/composition/set17/samira-reroll"
  },
  {
    "id": "comp-1776695008851",
    "name": "Dark Star",
    "tier": "A",
    "carries": [
      "Karma",
      "Jhin"
    ],
    "tank": "Nunu & Willump",
    "coreUnits": [
      "Lissandra",
      "Cho'Gath",
      "Karma",
      "Jhin",
      "Kai'Sa",
      "Nunu & Willump"
    ],
    "flexUnits": [
      "Tahm Kench",
      "Riven"
    ],
    "unitBuilds": [
      {
        "champion": "Karma",
        "coreItems": [
          "Spear of Shojin",
          "Jeweled Gauntlet",
          "Striker's Flail"
        ],
        "flexItems": [
          "Blue Buff"
        ]
      },
      {
        "champion": "Jhin",
        "coreItems": [
          "Infinity Edge",
          "Giant Slayer",
          "Deathblade"
        ],
        "flexItems": [
          "Hextech Gunblade"
        ]
      },
      {
        "champion": "Nunu & Willump",
        "coreItems": [
          "Protector's Vow",
          "Protector's Vow",
          "Protector's Vow"
        ],
        "flexItems": [
          "Spirit Visage",
          "Sunfire Cape",
          "Warmog's Armor",
          "Bramble Vest",
          "Dragon's Claw"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Bel'Veth",
      "Rek'Sai",
      "Briar",
      "Pantheon",
      "Ezreal"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [],
    "recommendedAugments": [
      "tft_augment_epicrolldown",
      "tft_augment_spreadingroots",
      "tft_augment_spreadingrootsplus",
      "tft_augment_traittree",
      "tft_augment_branchingout",
      "tft_augment_branchingoutplus",
      "tft_augment_traittreeplus"
    ],
    "augmentTiers": {
      "base": [],
      "good": [
        "tft_augment_epicrolldown",
        "tft_augment_spreadingroots",
        "tft_augment_spreadingrootsplus",
        "tft_augment_traittree",
        "tft_augment_branchingout",
        "tft_augment_branchingoutplus"
      ],
      "great": [
        "tft_augment_traittreeplus"
      ],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [],
      "great": [],
      "op": []
    },
    "emblemTiers": {
      "base": [
        "Brawler",
        "Shepherd",
        "Sniper",
        "Timebreaker",
        "Vanguard",
        "Voyager"
      ],
      "good": [
        "Rogue"
      ],
      "great": [
        "Dark Star"
      ],
      "op": []
    },
    "recommendedEmblems": [
      "Brawler",
      "Shepherd",
      "Sniper",
      "Timebreaker",
      "Vanguard",
      "Voyager",
      "Rogue",
      "Dark Star"
    ],
    "link": "https://tftflow.com/composition/set17/dark-star"
  },
  {
    "id": "comp-1776695633634",
    "name": "Sword Fighters",
    "tier": "B",
    "carries": [
      "Master Yi",
      "Riven"
    ],
    "tank": "Tahm Kench",
    "coreUnits": [
      "Aatrox",
      "Akali",
      "Gragas",
      "Rhaast",
      "Gwen",
      "Master Yi",
      "Riven",
      "Tahm Kench",
      "Shen"
    ],
    "flexUnits": [],
    "unitBuilds": [
      {
        "champion": "Master Yi",
        "coreItems": [
          "Malware Matrix",
          "Edge of Night",
          "Giant Slayer"
        ],
        "flexItems": [
          "Target-Lock Optics",
          "Sterak's Gage",
          "Hand of Justice",
          "Quicksilver"
        ]
      },
      {
        "champion": "Riven",
        "coreItems": [
          "Edge of Night",
          "Sterak's Gage",
          "Bloodthirster"
        ],
        "flexItems": []
      },
      {
        "champion": "Tahm Kench",
        "coreItems": [
          "Warmog's Armor",
          "Sunfire Cape",
          "Spirit Visage"
        ],
        "flexItems": [
          "Bramble Vest",
          "Dragon's Claw"
        ]
      }
    ],
    "carryBuilds": [],
    "keyComponents": [],
    "earlyGame": [
      "Pyke",
      "Caitlyn"
    ],
    "playstyle": "standard",
    "description": "",
    "recommendedConditions": [
      "psionic_malware_matrix",
      "psionic_target_lock_optics"
    ],
    "recommendedAugments": [
      "tft_augment_bronzeforlifei",
      "tft_augment_bronzeforlife2",
      "tft10_augment_littlebuddies",
      "tft_augment_epicrolldown"
    ],
    "augmentTiers": {
      "base": [
        "tft_augment_bronzeforlifei"
      ],
      "good": [
        "tft_augment_bronzeforlife2",
        "tft10_augment_littlebuddies",
        "tft_augment_epicrolldown"
      ],
      "great": [],
      "op": []
    },
    "artifactTiers": {
      "base": [],
      "good": [
        "Death's Defiance"
      ],
      "great": [],
      "op": []
    },
    "emblemTiers": {
      "base": [
        "N.O.V.A."
      ],
      "good": [],
      "great": [
        "Rogue"
      ],
      "op": []
    },
    "recommendedEmblems": [
      "N.O.V.A.",
      "Rogue"
    ],
    "link": "https://tftflow.com/composition/set17/riven-yi"
  }
]
